import { Column, Row, RowAlignedItems } from '@components/LinearLayout';
import { H2, P } from '@components/Typography';
import { scaleInType2, scaleOutType2 } from '@theme/animations';
import styled, { css } from 'styled-components';

import { EVENT_HOME_WIDTH } from '@utils/constants';

export const EventCoLocatedEventsSectionRoot = styled.div`
  width: min(${EVENT_HOME_WIDTH}, 100%);
  padding-bottom: 5rem;
  padding-top: 5rem;
  margin: auto;
  gap: 20rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding-left: 12rem;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1280}) {
    padding-left: 2rem;
    gap: 0;
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    display: flex;
    flex-direction: column;
    padding-left: 2rem;
    padding-right: 2rem;
  }
`;

export const CoLocatedDescriptionWrapper = styled(Column)`
  width: min(55rem, 100%);
  gap: 3rem;
  padding: 2rem 1rem;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    margin: auto;
  }
`;

export const CoLocatedLogosWrapper = styled(Row)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  gap: 3rem;

  @media only screen and (max-width: 720px) {
    grid-template-columns: repeat(1, 1fr);
    place-items: center;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size35};
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const CoLocatedNames = styled(P)`
  color: ${({ theme }) => theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size18};
  font-weight: ${({ theme }) => theme.fontWeight.weight500};
  margin-bottom: 4rem;
`;

export const Title = styled(H2)<{
  $textAlign?: string;
}>`
  color: ${({ theme }) => theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size35};
  font-weight: ${({ theme }) => theme.fontWeight.weight900};
  line-height: ${({ theme }) => theme.lineHeight.height125};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size35};
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size32};
    text-align: ${({ $textAlign }) => $textAlign ?? 'left'};
  }
`;

export const CoLocatedEventItemRoot = styled.div<{
  $isHovered: boolean;
  $isAnimationDisabled?: boolean;
}>`
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-gap: 3rem;

  background-color: ${({ theme }) => theme.color.white};
  border: 0.4rem solid ${({ theme }) => theme.color.strokeGrey};
  border-radius: ${({ theme }) => theme.borderRadius.radius10};
  cursor: pointer;
  padding: 2.8rem 1rem 1.25rem 1rem;

  width: 35rem; /** @TODO it was 37rem, but it was causing the page to have a vertical scrollbar */
  height: 42rem;

  ${({ $isAnimationDisabled, $isHovered }) =>
    $isAnimationDisabled
      ? null
      : $isHovered
        ? css`
            animation: ${scaleOutType2} 300ms ease-in forwards;
          `
        : css`
            animation: ${scaleInType2} 300ms ease-in forwards;
          `}

  @media only screen and (max-width: ${({ theme }) =>
    theme.breakpoint.width480}) {
    width: 100%;
  }
`;

export const LogoWrapper = styled(RowAlignedItems)`
  justify-content: center;
  max-height: 12rem;
`;

export const CompanyLogo = styled.img`
  height: 100%;
  width: 100%;
  object-fit: fill;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    width: 25rem;
  }
`;

export const EventDetailsDescription = styled(P)<{
  isTicketsSection?: boolean;
}>`
  color: ${({ theme }) => theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size18};
  line-height: ${({ theme }) => theme.lineHeight.height150};
  text-align: center;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    padding: ${({ isTicketsSection }) =>
      isTicketsSection ? '0 0.75rem' : '0'};
  }
`;

export const UnderlineContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const Underline = styled.div<{
  color?: string;
}>`
  width: 163px;
  height: 0.4rem;
  background-color: ${({ color, theme }) => color ?? theme.color.white};
`;

export const LogoGrid = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;

  gap: 2rem;
  margin-top: 4rem;
  margin-bottom: 1rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    flex-direction: column;
  }
`;

export const LogoItem = styled.img`
  width: 100%;
  height: 44px;

  object-fit: contain;
  margin: 0 auto;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    max-height: 40px;
  }
`;
